import {
  Control,
  FieldArrayWithId,
  FieldErrors,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormGetValues,
  UseFormRegister,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form'
import { AppConstantes } from '../../../../../utils/Constantes'
import { Recordatorios } from '../../../../recordatorios/Recordatorios'
import { TCondicionanteForm } from '../../../models/condicionanteForm.type'

type Props = {
  isModoEditar: boolean
  remove: UseFieldArrayRemove
  append: UseFieldArrayAppend<TCondicionanteForm, 'tareas'>
  control: Control<TCondicionanteForm>
  register: UseFormRegister<TCondicionanteForm>
  errors: FieldErrors<TCondicionanteForm>
  trigger: UseFormTrigger<TCondicionanteForm>
  getValues: UseFormGetValues<TCondicionanteForm>
  watch: UseFormWatch<TCondicionanteForm>
  index: number
  field: FieldArrayWithId<TCondicionanteForm,'tareas'>
  indexIdTareaConRecordatoriosAbiertos?: string
  actualizaListaDeTareasRedux: () => void
}
export const TareaCondicionanteModalCamposRecodatorios = ({
  isModoEditar,
  remove,
  append,
  control,
  register,
  errors,
  trigger,
  getValues,
  watch,
  index,
  field,
  indexIdTareaConRecordatoriosAbiertos,
  actualizaListaDeTareasRedux,
}: Props) => {
  // Wrapper de Recordatorios para una tarea dentro de condicionante.
  // En edicion el `idRelacionado` debe ser `idTarea` (persistido) para que Recordatorios
  // pueda crear/actualizar/eliminar en backend.
  return (
    <>
      <div className='mb-7 col-12'>
        <div
          className={`${
            getValues().tareas[index].idTarea === indexIdTareaConRecordatoriosAbiertos &&
            isModoEditar
              ? 'collapse show'
              : index.toString() === indexIdTareaConRecordatoriosAbiertos && !isModoEditar
              ? 'collapse show'
              : 'collapse'
          } `}
          id={`collapseExample-${index}`}>
          <div className='card card-body '>
            <div className='d-flex mb-3 ms-3 mt-7'>
              <div className='col-4'></div>
              <div className='col-6 ms-3'>
                <h5 className='me-15'>{`Recordatorios ${isModoEditar ? field.titulo : ''}`}</h5>
                <span className='text-muted fs-5'>
                  {getValues().tareas[index]?.recordatorios?.length} total
                </span>
              </div>
            </div>
            <div className='col-12 d-flex'>
              <div className='col-3'></div>
              <div
                className='ms-3'
                style={{
                  width: '50%',
                }}>
                <Recordatorios
                  isModoEditar={getValues().tareas[index].idTarea ? true : false}
                  fechaReferencia={getValues(`tareas.${index}.fechaTermino`)}
                  idRelacionado={getValues().tareas[index].idTarea}
                  tipo={AppConstantes.CVE_RECORDATORIO_TAREA}
                  indexObjetoPadre={index}
                  {...{
                    getValues,
                    trigger,
                    append,
                    remove,
                    watch,
                    control,
                    register,
                    errors,
                  }}
                  esAtributoAnidado={true}
                  actualizaRecordatorios={actualizaListaDeTareasRedux}></Recordatorios>
              </div>
            </div>
          </div>{' '}
        </div>{' '}
      </div>
    </>
  )
}
